import React from 'react';


// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { AdministrationService } from 'services/administration';
import { administration as AdministrationView } from 'ui/views/widgets/administration';
import { clearMemberManagementState } from 'resolvers/memberManagementState';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { Administration } from 'ui/containers/Administration';
 *
 * // render
 * <Administration propName='propValue'/>
 */
export class Administration extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // clear member management state
        clearMemberManagementState();

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.administrationService = new AdministrationService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'Administration.fetchComponentData()' );

        // cancel ongoing request
        this.administrationService.cancel();

        // get status and service data
        const { status, data } = await this.administrationService.fetchComponentData();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unMounts, cleanup resources.
     */
    componentWillUnmount() {
        this.administrationService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AdministrationView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
Administration.displayName = 'Administration';

// set default props
Administration.defaultProps = {};

// prop types
Administration.propTypes = {};
